import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  data() {
    return {
      items: [
        {
          id: 1,
          text: 'The most exciting engine in terms of political opinion',
          author: 'James Carville, Political Pundit',
        },
      ],
      swiperOptions: {
        autoplay: 3000,
        direction: 'horizontal',
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/quotes/quotes.js